/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Wh_SalesInputs */

const vi_sinp_wh_sales = /** @type {(inputs: Sinp_Wh_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho hàng bán`)
};

/**

* @param {Sinp_Wh_SalesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_wh_sales = /** @type {((inputs?: Sinp_Wh_SalesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Wh_SalesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_wh_sales(inputs)
});